// People pins on My Desk — individuals a manager wants in front of them.
import type { JSX } from 'preact';
import { PinnedBoard } from './PinnedBoard';

export function DeskPeople({ chromeless = false }: { chromeless?: boolean } = {}): JSX.Element {
  return (
    <PinnedBoard
      kind="person"
      title="People"
      empty="Nothing pinned."
      testId="desk-people"
      className="desk-people"
      chromeless={chromeless}
    />
  );
}
